<template>
  <v-card elevation="0">
    <alert-card
        v-if="alert.visible === true"
        v-model:visible="alert.visible"
        :type="alert.type"
        :title="alert.title"
        :text="alert.text"
        :closable="false"
        class="px-0"
    />
    <profile-contact-info-card
      v-model:is-loading="contactInfoForm.isLoading"
      v-model:is-editing="contactInfoForm.isEditing"
      v-model:init-firstname="contactInfoForm.firstname"
      v-model:init-lastname="contactInfoForm.lastname"
      v-model:email="contactInfoForm.email"
      v-model:init-phone="contactInfoForm.phone"
      v-model:init-address="contactInfoForm.address"
      @switch-edit-state="changeContactInfoEditState"
      @submit-profile="saveContactInfo"
    />
    <profile-password-card
      v-model:is-loading="passwordForm.isLoading"
      v-model:is-editing="passwordForm.isEditing"
      @switch-edit-state="changePasswordEditState"
      @submit-password="savePassword"
    />
  </v-card>
</template>

<script>

import {auth} from "@/common/auth";
import {router} from "@/router";
import {api} from "@/common/api";
import {inject} from "vue";
import AlertCard from "@/components/AlertCard.vue";
import {messages} from "@/common/enum/messages";
import ProfileContactInfoCard from "@/components/Profile/ProfileContactInfoCard.vue";
import ProfilePasswordCard from "@/components/Profile/ProfilePasswordCard.vue";

export default {
  name: "UserProfileView",
  components: {ProfilePasswordCard, ProfileContactInfoCard, AlertCard},
  data() {
    return {
      tab: 'profile',
      contactInfoForm: {
        isLoading: false,
        isEditing: false,
        id: null,
        firstname: null,
        lastname: null,
        email: null,
        phone: null,
        address: null
      },
      passwordForm: {
        isLoading: false,
        isEditing: false,
        currentPassword: null,
        newPassword: null,
        repeatedNewPassword: null
      },
      alert: {
        visible: false,
        type: 'error',
        title: 'Error',
        text: ''
      }
    }
  },
  mounted() {
    this.getProfile()
  },
  setup() {
    return {
      switchAuthorizationState: inject('authorization').switchState
    }
  },
  methods: {
    async getToken() {
      const token = auth.getToken()
      if (token == null) {
        this.switchAuthorizationState()
        await router.push({name: 'sign-in', state: {redirectTo: 'profile'}})
        return
      }
      return token
    },
    async getProfile() {
      const token = await this.getToken()
      this.contactInfoForm.isLoading = true
      let response = await api.getProfile(token)
      this.contactInfoForm.email = auth.getUsername()
      this.handleContactInfoResponse(response)
    },
    async saveContactInfo(contactInfo) {
      const token = await this.getToken()
      this.contactInfoForm.isLoading = true
      if (this.contactInfoForm.id === null) {
        let response = await api.createProfile(token, {
          first_name: contactInfo.firstname,
          last_name: contactInfo.lastname,
          phone: contactInfo.phone,
          address: contactInfo.address
        })
        this.handleContactInfoResponse(response)
      } else {
        let response = await api.updateProfile(token, {
          first_name: contactInfo.firstname,
          last_name: contactInfo.lastname,
          phone: contactInfo.phone,
          address: contactInfo.address
        })
        this.handleContactInfoResponse(response)
      }
    },
    handleContactInfoResponse(response) {
      if (this.verifyError(response)) {
        this.showError(response.data?.message)
      } else {
        this.hideError()
        this.contactInfoForm.isEditing = false
        this.parseProfileResponse(response)
      }
      this.contactInfoForm.isLoading = false
    },
    verifyError(response) {
      return response?.data?.status === 'error'
    },
    hideError() {
      this.alert.visible = false
    },
    showError(message) {
      this.alert.visible = true
      this.alert.type = 'error'
      this.alert.title = 'Error'
      this.alert.text = message?.length === 0 ? messages.en.profile_view.profile_editing_error : message
    },
    parseProfileResponse(response) {
      this.contactInfoForm.id = response.data.id
      this.contactInfoForm.firstname = response.data.first_name
      this.contactInfoForm.lastname = response.data.last_name
      this.contactInfoForm.phone = response.data.phone
      this.contactInfoForm.address = response.data.address
    },
    changeContactInfoEditState() {
      this.hideError()
      this.contactInfoForm.isEditing = !this.contactInfoForm.isEditing
    },
    changePasswordEditState() {
      this.hideError()
      this.passwordForm.isEditing = !this.passwordForm.isEditing
    },
    async savePassword(passwordInfo) {
      const token = await this.getToken()
      this.passwordForm.isLoading = true
      let response = await api.updatePassword(token, {
        current_password: passwordInfo.currentPassword,
        new_password: passwordInfo.newPassword
      })
      this.handlePasswordResponse(response)
    },
    handlePasswordResponse(response) {
      if (this.verifyError(response)) {
        this.showError(response.data?.message)
      } else {
        this.hideError()
        this.passwordForm.isEditing = false
      }
      this.passwordForm.isLoading = false
    },
  },
}
</script>

<style scoped>

</style>